module.exports = __webpack_public_path__ + "static/media/game_cover_archero.b6268c46.png";